"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.clearHighlight = exports.highlightAssembly = exports.clearGeneratedProjectFromScene = exports.applyGeneratedProjectToScene = void 0;
const THREE = __importStar(require("three"));
const BaseObject3D_3d_1 = __importDefault(require("~/components/Cad3d/classes/BaseObject3D.3d"));
const ConnectionManager_3d_1 = __importDefault(require("~/components/Cad3d/classes/ConnectionManager.3d"));
const commands_1 = require("~/components/Cad3d/commands");
const FastenersUtils_1 = require("~/components/Cad3d/utils/FastenersUtils");
const Viewer_1 = __importDefault(require("~/components/Cad3d/Viewer"));
const types_1 = require("~/store/types");
const aiSceneRegistry_1 = require("./aiSceneRegistry");
function structuresNest(a, b) {
    const isEnclosure = (structure) => structure === 'enclosure' || structure === 'machineBarrier';
    return (a === 'workbench' && isEnclosure(b)) || (b === 'workbench' && isEnclosure(a));
}
function createGeneratedConnectionItem(object, isMain) {
    var _a, _b;
    return {
        uuid: object.uuid,
        isMain,
        itemNumber: object.partDetails.itemNumber,
        itemType: object.type,
        componentType: object.partDetails.componentType,
        connectedSide: null,
        endFace: null,
        size: object.getLength(),
        geomkernelPosition: object.position.clone(),
        geomkernelPanelSize: object.getSize(),
        position: (_a = object.originalPosition) !== null && _a !== void 0 ? _a : object.position.clone(),
        panelSize: (_b = object.originalPanelSize) !== null && _b !== void 0 ? _b : object.getSize(),
        rotation: {
            x: object.quaternion.x,
            y: object.quaternion.y,
            z: object.quaternion.z,
            w: object.quaternion.w,
        },
    };
}
function applyGeneratedCollisionExclusions(items, objectsByTempId) {
    const { connectionManager } = Viewer_1.default.instance.getDesignProMain();
    const processedPairs = new Set();
    const connectionPromises = [];
    items.forEach((item) => {
        var _a;
        if (!item.tempId || !((_a = item.collisionExcludeTempIds) === null || _a === void 0 ? void 0 : _a.length)) {
            return;
        }
        const object = objectsByTempId.get(item.tempId);
        if (!object) {
            return;
        }
        item.collisionExcludeTempIds.forEach((excludeTempId) => {
            const connectedObject = objectsByTempId.get(excludeTempId);
            if (!connectedObject) {
                return;
            }
            const pairKey = [object.uuid, connectedObject.uuid].sort().join(':');
            if (processedPairs.has(pairKey)) {
                return;
            }
            processedPairs.add(pairKey);
            if (connectionManager.findConnectionObjectBetween(object.uuid, connectedObject.uuid)) {
                return;
            }
            let connectionType = types_1.CONNECTION_TYPE.COMPONENT;
            try {
                connectionType = ConnectionManager_3d_1.default.getConnectionType(object, connectedObject);
            }
            catch (_a) {
                // Some AI collision exclusions are intentional contact pairs rather than snappable catalog joints.
                connectionType = types_1.CONNECTION_TYPE.COMPONENT;
            }
            connectionPromises.push(connectionManager
                .restoreConnection(object, connectedObject, createGeneratedConnectionItem(object, true), createGeneratedConnectionItem(connectedObject, false), connectionType, THREE.MathUtils.generateUUID(), [])
                .then((connectionObject) => (0, FastenersUtils_1.updateFastenersForConnection)(object, connectedObject, connectionObject)));
        });
    });
    return connectionPromises;
}
function isFiniteVector(vector) {
    return Number.isFinite(vector.x) && Number.isFinite(vector.y) && Number.isFinite(vector.z);
}
function isFiniteRotation(rotation) {
    return (Number.isFinite(rotation.x) &&
        Number.isFinite(rotation.y) &&
        Number.isFinite(rotation.z) &&
        Number.isFinite(rotation.w));
}
function collectAiFastenerDefaults(objects) {
    const defaults = {};
    const { connectionManager } = Viewer_1.default.instance.getDesignProMain();
    objects.forEach((object) => {
        var _a;
        const objectDefaults = (_a = object.userData) === null || _a === void 0 ? void 0 : _a.aiFastenerDefaults;
        if (objectDefaults) {
            Object.assign(defaults, objectDefaults);
        }
        connectionManager.getRelatedConnections(object).forEach((connection) => {
            if (!connection.fastenerItemNumber) {
                return;
            }
            defaults[String(connection.connectionType)] = {
                itemNumber: connection.fastenerItemNumber,
                distanceToTheEdge: connection.distanceToTheEdge,
                holeDepth: connection.holeDepth,
            };
        });
    });
    return defaults;
}
const applyGeneratedProjectToScene = (allCatalogData, aiResponse) => __awaiter(void 0, void 0, void 0, function* () {
    var _a;
    const viewer = Viewer_1.default.instance;
    const designProMain = viewer.getDesignProMain();
    const { historyService } = designProMain;
    const assemblyId = aiResponse.assembly.id;
    let aiFastenerDefaults = {};
    const aiPlanUpdatedAt = Date.now();
    let isReplacement = false;
    let oldCenterX = 0;
    // A matching assembly id means this is an edit, so replace its existing geometry.
    if ((0, aiSceneRegistry_1.getRegisteredAiAssemblyObjects)(assemblyId).length > 0) {
        const registeredObjects = (0, aiSceneRegistry_1.getRegisteredAiAssemblyObjects)(assemblyId);
        const objectsToReplace = [...registeredObjects];
        if (!objectsToReplace.length) {
            viewer.getScene().traverse((object) => {
                var _a;
                const baseObject = object;
                if (((_a = baseObject.userData) === null || _a === void 0 ? void 0 : _a.aiAssemblyId) === assemblyId) {
                    objectsToReplace.push(baseObject);
                }
            });
        }
        if (objectsToReplace.length) {
            // Save the mesh’s current X position before removal so the rebuilt assembly stays in the same place.
            const oldBox = new THREE.Box3();
            objectsToReplace.forEach((o) => oldBox.expandByObject(o));
            oldCenterX = (oldBox.min.x + oldBox.max.x) / 2;
            aiFastenerDefaults = collectAiFastenerDefaults(objectsToReplace);
            historyService.execute(new commands_1.RemoveObjectCommand(objectsToReplace, viewer, historyService));
            (0, aiSceneRegistry_1.unregisterAiAssembly)(assemblyId);
            isReplacement = true;
        }
    }
    if (!((_a = aiResponse.items) === null || _a === void 0 ? void 0 : _a.length)) {
        return {
            insertedCount: 0,
            skippedItems: [],
        };
    }
    const catalogByItemNumber = new Map(allCatalogData.map((item) => [item.item_number, item]));
    const uniqueItemNumbers = [...new Set(aiResponse.items.map((i) => String(i.itemNumber)))];
    const catalogItems = uniqueItemNumbers.map((num) => catalogByItemNumber.get(num)).filter(Boolean);
    const models = yield designProMain.loadModels(catalogItems);
    const modelsByItemNumber = new Map(models
        .filter((model) => !!model)
        .map((model) => [String(model.partDetails.itemNumber), model]));
    const objects = [];
    const objectsByTempId = new Map();
    const skippedItems = [];
    aiResponse.items.forEach((item) => {
        var _a, _b, _c;
        const itemNumberStr = String(item.itemNumber);
        const catalogItem = catalogByItemNumber.get(itemNumberStr);
        const model = modelsByItemNumber.get(itemNumberStr);
        if (!model || !catalogItem || !isFiniteVector(item.position) || !isFiniteRotation(item.rotation)) {
            skippedItems.push(item);
            return;
        }
        const object = model.clone();
        object.initBoxes();
        object.setCatalogProps(catalogItem);
        object.userData.aiAssemblyId = assemblyId;
        object.userData.aiMemberId = item.tempId;
        object.userData.aiCollisionExcludeMemberIds = item.collisionExcludeTempIds;
        object.userData.aiAssembly = aiResponse.assembly;
        object.userData.aiPlanUpdatedAt = aiPlanUpdatedAt;
        if (Object.keys(aiFastenerDefaults).length) {
            object.userData.aiFastenerDefaults = aiFastenerDefaults;
        }
        if (catalogItem.is_scalable && (item.dimensions || item.size)) {
            const currentSize = object.getSize().clone();
            if (item.dimensions) {
                currentSize.set((_a = item.dimensions.x) !== null && _a !== void 0 ? _a : currentSize.x, (_b = item.dimensions.y) !== null && _b !== void 0 ? _b : currentSize.y, (_c = item.dimensions.z) !== null && _c !== void 0 ? _c : currentSize.z);
            }
            else if (item.size) {
                currentSize.setZ(item.size);
            }
            object.setSize(currentSize, false);
        }
        object.setRotation(new THREE.Quaternion(item.rotation.x, item.rotation.y, item.rotation.z, item.rotation.w));
        object.setPosition(new THREE.Vector3(item.position.x, item.position.y, item.position.z));
        objects.push(object);
        if (item.tempId) {
            objectsByTempId.set(item.tempId, object);
        }
    });
    if (!objects.length) {
        return {
            insertedCount: 0,
            skippedItems,
        };
    }
    // Align new assembly floor to the grid plane (world Z = 0) so structures always sit on the ground.
    const newFloorZ = Math.max(...objects.map((o) => o.position.z));
    const zShift = -newFloorZ;
    if (Math.abs(zShift) > 0.01) {
        objects.forEach((o) => o.setPosition(o.position.clone().setZ(o.position.z + zShift)));
    }
    // Offset assemblies unless a workbench nests inside an enclosure or machine barrier.
    // Edits (replacements) preserve position — don't offset rebuilt assemblies.
    const existingAi = viewer
        .getScene()
        .children.filter((c) => c instanceof BaseObject3D_3d_1.default && !!c.userData.aiAssemblyId && c.userData.aiAssemblyId !== assemblyId);
    const blockingAi = existingAi.filter((object) => {
        var _a;
        return !structuresNest(aiResponse.assembly.structure, (_a = object.userData.aiAssembly) === null || _a === void 0 ? void 0 : _a.structure);
    });
    if (blockingAi.length && !isReplacement) {
        const existingBox = new THREE.Box3();
        blockingAi.forEach((o) => existingBox.expandByObject(o));
        const newBox = new THREE.Box3();
        objects.forEach((o) => newBox.expandByObject(o));
        const xShift = existingBox.max.x - newBox.min.x + 10;
        if (xShift > 0.01) {
            objects.forEach((o) => o.setPosition(o.position.clone().setX(o.position.x + xShift)));
        }
    }
    // For rebuilt assemblies, restore the previous center X position.
    if (isReplacement && objects.length) {
        const newBox = new THREE.Box3();
        objects.forEach((o) => newBox.expandByObject(o));
        const newCenterX = (newBox.min.x + newBox.max.x) / 2;
        const xShift = oldCenterX - newCenterX;
        if (Math.abs(xShift) > 0.01) {
            objects.forEach((o) => o.setPosition(o.position.clone().setX(o.position.x + xShift)));
        }
    }
    const cmd = new commands_1.AddObjectCommand(objects, viewer, historyService, undefined, () => applyGeneratedCollisionExclusions(aiResponse.items, objectsByTempId));
    historyService.execute(cmd);
    (0, aiSceneRegistry_1.registerAiAssemblyObjects)(assemblyId, objects, aiResponse.assembly, aiPlanUpdatedAt);
    return {
        insertedCount: objects.length,
        skippedItems,
    };
});
exports.applyGeneratedProjectToScene = applyGeneratedProjectToScene;
function clearGeneratedProjectFromScene() {
    const viewer = Viewer_1.default.instance;
    const { historyService } = viewer.getDesignProMain();
    const assemblies = (0, aiSceneRegistry_1.getRegisteredAiAssemblyIds)();
    const objects = assemblies.flatMap((assemblyId) => (0, aiSceneRegistry_1.getRegisteredAiAssemblyObjects)(assemblyId));
    if (objects.length) {
        historyService.execute(new commands_1.RemoveObjectCommand(objects, viewer, historyService));
    }
    assemblies.forEach(aiSceneRegistry_1.unregisterAiAssembly);
}
exports.clearGeneratedProjectFromScene = clearGeneratedProjectFromScene;
let activeHighlight = null;
function highlightAssembly(assemblyId) {
    clearHighlight();
    const objects = (0, aiSceneRegistry_1.getRegisteredAiAssemblyObjects)(assemblyId);
    if (!objects.length)
        return;
    const scene = Viewer_1.default.instance.getScene();
    const boxHelpers = [];
    const savedEmissive = [];
    objects.forEach((object) => {
        const box = new THREE.BoxHelper(object, 0xe15e37);
        scene.add(box);
        boxHelpers.push(box);
        object.traverse((child) => {
            if (child instanceof THREE.Mesh) {
                const mat = child.material;
                if (mat.emissive instanceof THREE.Color) {
                    savedEmissive.push({ material: mat, savedColor: mat.emissive.clone() });
                    mat.emissive.setHex(0x2a1400);
                }
            }
        });
    });
    activeHighlight = { boxHelpers, savedEmissive };
}
exports.highlightAssembly = highlightAssembly;
function clearHighlight() {
    if (!activeHighlight)
        return;
    const scene = Viewer_1.default.instance.getScene();
    activeHighlight.boxHelpers.forEach((box) => {
        scene.remove(box);
        box.geometry.dispose();
    });
    activeHighlight.savedEmissive.forEach(({ material, savedColor }) => {
        material.emissive.copy(savedColor);
    });
    activeHighlight = null;
}
exports.clearHighlight = clearHighlight;
